import React, { useState } from "react";
import review1 from "../assets/review1.jpeg";
import review2 from "../assets/review2.jpeg";
import review3 from "../assets/review3.jpeg";
const testimonials = [
  {
    image: review1,
    text: "All dress super quality mam. Super fast delivery. Shop la poi purchase pannalum ippadi low cast la kedaikathu. Thankyou so much",
    rating: 5,
  },
  {
    image: review2,
    text: "Received mam,nice color and quality👌 very comfortable to wear thnk u mam..",
    rating: 5,
  },
  {
    image: review3,
    text: "Quality of the cloth adichuka va mudiyathu semma quality intha price ku Evalo quality eathir pakava illa thank you so much sis😍🫂",
    rating: 5,
  },
];
export default function Testimonials() {
  const [selectedImage, setSelectedImage] = useState(null);
  return (
    <div className="testimonial-section">
      <h2>Loved by Senthan Families</h2>
      <div className="testimonial-sub">
        ⭐ 4.9/5 from 1200+ parents &nbsp;&nbsp; 👨‍👩‍👧 Loved by 10,000+ families
      </div>
      <div className="testimonial-container">
        {testimonials.map((item, index) => (
          <div className="testimonial-card" key={index}>
            <div className="quote">❝</div>
            <img src={item.image} alt="" className="avatar" onClick={() => setSelectedImage(item.image)} />
            <p className="review">"{item.text}"</p>
            <div className="stars">
              {"⭐".repeat(item.rating)} <span>5.0</span>
            </div>
          </div>
        ))}
      </div>
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <div className="image-wrapper" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn" onClick={() => setSelectedImage(null)}>✖</span>
            <img src={selectedImage} className="image-preview" />
          </div>
        </div>
      )}
    </div>
  );
}